import FileContainer from './FileContainer'

export default FileContainer